/**
 * @class Subscription
 * Represents a subscription with ability to remove itself.
 */
var Subscription = /** @class */ (function () {
    function Subscription(subscriber) {
        this.subscriber = subscriber;
        this.eventType = '';
        this.index = -1;
    }
    Subscription.prototype.remove = function () {
        if (this.subscriber) {
            this.subscriber.removeSubscription(this);
            this.subscriber = null;
        }
    };
    return Subscription;
}());
export default Subscription;
//# sourceMappingURL=baseSubscription.js.map